import PropTypes from "prop-types"
import React from "react"

import { Switch, BrowserRouter as Router } from "react-router-dom"
import { connect, useDispatch } from "react-redux"

// Import Routes all
import { authProtectedRoutes, publicRoutes, authProtectedRoutesCategory } from "./routes"

// Import all middleware
import Authmiddleware from "./routes/route"

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css"
// Import scss
import "./assets/scss/theme.scss"

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

import fakeBackend from "./helpers/AuthType/fakeBackend"
import {
  LoginUserData,
  LoginAccessSetting,
  LoginAccessUserDetails,
} from "store/actions"

// Activating fake backend only in development mode when no real API is configured
if (process.env.NODE_ENV === 'development' && !process.env.REACT_APP_API_URL) {
  fakeBackend()
}

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig);

const App = props => {
  const dispatch = useDispatch()

  const companySetting =
    JSON.parse(localStorage.getItem("authUser") || "{}")?.data
      ?.companysetting || {}

  const commonCategoryName = {
    MainCategory: companySetting?.maincategoryname,
    SubCategory: companySetting?.subcategoryname,
  }

  dispatch(LoginUserData(commonCategoryName))

  const accessSetting =
    JSON.parse(localStorage.getItem("authUser") || "{}")?.data
      ?.useraccessgroupsettings || {}
  const commonhide_show = {
    accessAllTeam: accessSetting?.accessAllTeam,
    createMainCat: accessSetting?.createMainCat,
    createSubCat: accessSetting?.createSubCat,
    createTrackProfile: accessSetting?.accessAllTeam,
    createUser: accessSetting?.createUser,
    createTeam: accessSetting?.createTeam,
    manageAccessGroup: accessSetting?.manageAccessGroup,
  }

  dispatch(LoginAccessSetting(commonhide_show))

  const UserDetails =
    JSON.parse(localStorage.getItem("authUser") || "{}")?.data || {}

  dispatch(LoginAccessUserDetails(UserDetails))
  const accessgroupname = UserDetails.accessgroupname === "CategoryUser"

  function getLayout() {
    let layoutCls = VerticalLayout
    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout
        break
      default:
        layoutCls = VerticalLayout
        break
    }
    return layoutCls
  }

  const Layout = getLayout()
  
  return (
    <React.Fragment>
      <Router>
        <Switch>


          {!accessgroupname && authProtectedRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              hasAccess={route.hasAccess}
              key={idx}
              isAuthProtected={true}
              exact
            />
          ))}
          {accessgroupname && authProtectedRoutesCategory.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              hasAccess={route.hasAccess}
              key={idx}
              isAuthProtected={true}
              isworkReport={true}
              exact
            />
          ))}
          {publicRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={NonAuthLayout}
              component={route.component}
              key={idx}
              isAuthProtected={false}
              exact
            />
          ))}
        </Switch>
      </Router>

      {props.loader ? <div id="cover-spin"></div> : null}
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
    loader: state.globalLists.pageLoader,
  }
}

export default connect(mapStateToProps, null)(App)
